
import Bottle from '../../../assets/images/Photo/bottle.jpg'
import ArrowRight from '../../../assets/images/Doodles/arrow_right.svg'
import { useTranslation } from 'react-i18next';

function Sponsorship({ className, isExpanded, onToggle }) {
  const { t } = useTranslation(['common']);

  return (
    <div
      className={`relative h-full bg-black overflow-hidden cursor-pointer transition-all duration-500 ease-in-out ${
        isExpanded 
          ? 'flex-none w-full'           // Cuando está expandido, toma todo el ancho
          : 'flex-1 min-w-0'            // Cuando está contraído, se reparte equitativamente
      } ${className}`}
      onClick={onToggle}
    >
      {/* Imagen de fondo */}
      <img
        src={Bottle}
        alt=""
        className={`object-cover w-full h-full  ${
            isExpanded ? 'blur-sm' : 'blur-none'
        }`}
        />

      
      {/* Overlay gradiente */}
      <div className='h-full w-full opacity-60 absolute top-0 left-0 bg-gradient-to-br from-bluekali-black to-bluekali-cerulean-blue'/>
      
      {/* Contenido principal - siempre visible */}
      { !isExpanded &&
      <div className='absolute top-0 left-0 pt-8 pl-6 w-100'>
        <h2 className="text-white text-3xl font-medium mb-4">
          {t('solutions.sol2.title')}
        </h2>
        <p className='text-white/80 text-sm leading-relaxed w-3/4 solutions-text-appear'>
          {t('solutions.sol2.shortdesc')}
        </p>
      </div>
      }

      {/* Contenido expandido - solo visible cuando se expande */}
      <div className={`absolute top-0 left-0 pt-8 pl-6 pr-8 pb-8 h-full transition-all duration-500 ${
        isExpanded ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8 pointer-events-none'
      }`}>
        <div className="text-white h-full flex flex-col justify-start items-start">
          <h2 className="text-white text-3xl font-medium mb-4">
          {t('solutions.sol2.title')}
          </h2>
          <p className='text-white/80 text-sm leading-relaxed w-3/4 solutions-text-appear'>
            {t('solutions.sol2.desc')}
          </p>
          
          <div className="flex w-full mt-4 space-x-4 items-start h-3/5">
            <div className='bg-bluekali-cerulean-blue/80 p-4 rounded-md'>
              <h3 className="text-xl font-semibold mb-2">{t('solutions.sol2.types')}</h3>
              <ul className="space-y-2 text-sm">
                <li>
                • <span className="font-semibold">{t('solutions.sol2.clean')}&nbsp;</span>{t('solutions.sol2.clean_desc')}
                </li>
                <li>
                • <span className="font-semibold">{t('solutions.sol2.blue')}&nbsp;</span>{t('solutions.sol2.blue_desc')}
                </li>
                <li>
                • <span className="font-semibold">{t('solutions.sol2.workshop')}&nbsp;</span>{t('solutions.sol2.workshop_desc')}
                </li>
                <li>
                • <span className="font-semibold">{t('solutions.sol2.event')}&nbsp;</span>{t('solutions.sol2.event_desc')}
                </li>
              </ul>
            </div>

            <div className='bg-bluekali-gray/80 text-bluekali-navy-blue p-4 w-3/4 rounded-md'>
              <h3 className="text-xl font-semibold mb-2">{t('solutions.sol2.locations')}</h3>
              <ul className="space-y-2 text-sm">
                <li>{t('solutions.sol2.locations')}</li>
                <li>{t('solutions.sol2.xalapa')}</li>
                <li>{t('solutions.sol2.edomex')}</li>
                <li>{t('solutions.sol2.evaluate')}</li>
              </ul>
            </div>

            
          </div>

        </div>
      </div>

      {/* Botón Read More/Less */}
      <div className='absolute bottom-0 right-0 pr-8 pb-8 flex space-x-6'>
        { isExpanded &&
        <a
        className='bg-bluekali-tomato text-white px-6 py-2 rounded-lg hover:bg-opacity-80 transition-colors mt-4'
         href="/Solutions.pdf" target="_blank" rel="noopener noreferrer">
          {t('solutions.learnmore')}
        </a>
        }

        <button
            className={`flex items-center px-6 py-2 rounded-lg hover:bg-opacity-80 transition-colors mt-4
            ${isExpanded ? 'bg-bluekali-gray/80 text-bluekali-black' : 'bg-transparent text-bluekali-white '}
            `}
            onClick={(e) => {
                e.stopPropagation();  
                onToggle();
            }}
            >
            <p className={`font-bold mr-3 text-sm  transition-opacity ${
            isExpanded ? 'hidden' : 'block'
          }`}>
            {t('solutions.readmore')}
          </p>
          <p className={`font-bold mr-3 text-sm  transition-opacity ${
            isExpanded ? 'block' : 'hidden'
          }`}>
            {t('solutions.readless')}
          </p>
          <img 
            src={ArrowRight} 
            alt='' 
            className={`h-5 w-5 transition-transform duration-300 group-hover:translate-x-1 ${
              isExpanded ? 'rotate-180 brightness-0' : 'rotate-0 brightness-100'
            }`}
          />
        </button>
      </div>
    </div>
  )
}

export default Sponsorship